import React from "react";
import PowerBiEmbed from "../../components/powerBiEmbed";
import { ReportUrls } from "../../constants/reportUrls";
import {SFPageContainer } from "@sf-core";

const AcademiesDashboard = () => (
  <SFPageContainer disableGutters>
    <PowerBiEmbed url={ReportUrls.AcademiesDashboard} />
  </SFPageContainer>
);

export default AcademiesDashboard;
